<template>
  <div class="page" id="page-my-insurance">

    <!--
    <div class="layer"></div>
  -->

    <div class="section" id="section-my-insurance-landing">
      <div class="container">
        <h1>MY보험</h1>
        <p class="logout" v-if="this.$store.state.customer.profile._id" @click="logout">로그아웃</router-link></p>
        <!--<p class="login" v-if="!this.$store.state.customer.profile._id"><router-link :to="{ name: 'Auth' }">로그인</router-link></p>-->
        <p v-if="!this.$store.state.customer.profile._id"><router-link class="login" :to="{ name: 'Auth' }">로그인</router-link>이 필요한 서비스입니다.</p>
        <p v-if="this.$store.state.customer.profile._id">안녕하세요. {{this.$store.state.customer.profile.customer_name}}님</p>
        <div v-if="distance !== 0 && this.$store.state.customer.profile._id">
          <p class="mb-1">사용 가능한 누적 견인거리는 <b style="color: #174be6">{{ distance }}</b> 입니다.</p>
          <router-link to="/gift?tab=긴급견인%2020km%20추가"><button class="distance-guide">이용 방법 보기</button></router-link>
        </div>
      </div>
    </div>

    <div class="section" id="section-my-insurance-introduction">
      <div class="container">
        <div class="section-header">
          <div class="container">
            <element-tab>
              <element-tab-item @click="introductionTab = '비교견적'" :on="introductionTab == '비교견적'">비교견적</element-tab-item>
              <element-tab-item @click="introductionTab = '가입보험'" :on="introductionTab == '가입보험'">가입보험</element-tab-item>
              <element-tab-item @click="introductionTab = '계약변경'" :on="introductionTab == '계약변경'">계약변경</element-tab-item>
              <element-tab-item @click="introductionTab = '사고보상'" :on="introductionTab == '사고보상'">사고보상</element-tab-item>
            </element-tab>
          </div>
        </div>
        <div class="section-body">
          <div class="container">

            <div id="introduction-tab-service" v-if="introductionTab == '비교견적'">
              <div class="subsection">
                <div class="subsection-header">
                  <div class="container">
                    <element-tab id="inner-element-tab">
                      <element-tab-item @click="myInsuranceTab = '전체'" :on="myInsuranceTab == '전체'">전체<br/><p>{{ insureEstimateList.length }}</p></element-tab-item>
                      <element-tab-item @click="myInsuranceTab = '자동차'" :on="myInsuranceTab == '자동차'">자동차<br/><p>{{ insureEstimateList.filter(o => o.type === '자동차보험').length }}</p></element-tab-item>
                      <element-tab-item @click="myInsuranceTab = '장기·생명'" :on="myInsuranceTab == '장기·생명'">장기·생명<br/><p>{{ insureEstimateList.filter(o => o.type === '민영의료보험' || o.type === '운전자보험' || o.type === '태아보험' || o.type === '정기보험' || o.type === '실손의료보험' || o.type === '건강보험' || o.type === '어린이보험' || o.type === '종신보험' || o.type === '암/2대질병 보험' || o.type === '치아보험' || o.type === '치매보험' ).length }}</p></element-tab-item>
                      <element-tab-item @click="myInsuranceTab = '화재·기타'" :on="myInsuranceTab == '화재·기타'">화재·기타<br/><p>{{ insureEstimateList.filter(o => o.type === '상해보험' || o.type === '펫보험' || o.type === '연금보험' || o.type === '화재보험').length }}</p></element-tab-item>
                    </element-tab>
                  </div>
                </div>

                <div id="myinsurance-tab-service">
                  <element-insure-item :data="filterList(insureEstimateList)" :type="'비교견적'" :key="'비교견적'"/>
                </div>

              </div>
            </div>

            <div id="introduction-tab-service" v-if="introductionTab == '가입보험'">
              <div class="subsection">
                <div class="subsection-header">
                  <div class="container">
                    <element-tab id="inner-element-tab">
                      <element-tab-item @click="myInsuranceTab = '전체'" :on="myInsuranceTab == '전체'">전체<br/><p>{{ insureSubscriptionList.length }}</p></element-tab-item>
                      <element-tab-item @click="myInsuranceTab = '자동차'" :on="myInsuranceTab == '자동차'">자동차<br/><p>{{ insureSubscriptionList.filter(o => o.type === '자동차보험').length }}</p></element-tab-item>
                      <element-tab-item @click="myInsuranceTab = '장기·생명'" :on="myInsuranceTab == '장기·생명'">장기·생명<br/><p>{{ insureSubscriptionList.filter(o => o.type === '민영의료보험' || o.type === '운전자보험' || o.type === '태아보험' || o.type === '정기보험' || o.type === '실손의료보험' || o.type === '건강보험' || o.type === '어린이보험' || o.type === '종신보험' || o.type === '암/2대질병 보험' || o.type === '치아보험' || o.type === '치매보험' ).length }}</p></element-tab-item>
                      <element-tab-item @click="myInsuranceTab = '화재·기타'" :on="myInsuranceTab == '화재·기타'">화재·기타<br/><p>{{ insureSubscriptionList.filter(o => o.type === '상해보험' || o.type === '펫보험' || o.type === '연금보험' || o.type === '화재보험').length }}</p></element-tab-item>
                    </element-tab>
                  </div>
                </div>

                <div id="myinsurance-tab-service">
                  <element-insure-item :data="filterList(insureSubscriptionList)" :type="'가입보험'" :key="'가입보험'"/>
                </div>

              </div>
            </div>

            <div id="introduction-tab-service" v-if="introductionTab == '계약변경'">
              <div class="subsection">
                <div class="container">
                  <div class="subsection-header">
                    <div class="container">
                      <element-tab id="inner-element-tab">
                        <element-tab-item @click="myInsuranceTab = '전체'" :on="myInsuranceTab == '전체'">전체<br/><p>{{ insureChangeContractList.length }}</p></element-tab-item>
                        <element-tab-item @click="myInsuranceTab = '자동차'" :on="myInsuranceTab == '자동차'">자동차<br/><p>{{ insureChangeContractList.filter(o => o.type === '자동차보험').length }}</p></element-tab-item>
                        <element-tab-item @click="myInsuranceTab = '장기·생명'" :on="myInsuranceTab == '장기·생명'">장기·생명<br/><p>{{ insureChangeContractList.filter(o => o.type === '민영의료보험' || o.type === '운전자보험' || o.type === '태아보험' || o.type === '정기보험' || o.type === '실손의료보험' || o.type === '건강보험' || o.type === '어린이보험' || o.type === '종신보험' || o.type === '암/2대질병 보험' || o.type === '치아보험' || o.type === '치매보험' ).length }}</p></element-tab-item>
                        <element-tab-item @click="myInsuranceTab = '화재·기타'" :on="myInsuranceTab == '화재·기타'">화재·기타<br/><p>{{ insureChangeContractList.filter(o => o.type === '상해보험' || o.type === '펫보험' || o.type === '연금보험' || o.type === '화재보험').length }}</p></element-tab-item>
                      </element-tab>
                    </div>
                  </div>

                  <div id="myinsurance-tab-service">
                    <element-insure-item :data="filterList(insureChangeContractList)" :type="'계약변경'" :key="'계약변경'"/>
                  </div>
                </div>
              </div>
            </div>

            <div id="introduction-tab-service" v-if="introductionTab == '사고보상'">
              <div class="subsection">
                <div class="container">
                  <div class="subsection-header">
                    <div class="container">
                      <element-tab id="inner-element-tab">                        
                        <element-tab-item @click="myInsuranceTab = '정비·수리'" :on="myInsuranceTab == '정비·수리'">정비·수리<br/><p>{{ repairList.length }}</p></element-tab-item>
                        <element-tab-item @click="myInsuranceTab = '자동차'" :on="myInsuranceTab == '자동차'">자동차<br/><p>{{ insureAccidentList.filter(o => o.type === '자동차보험').length }}</p></element-tab-item>
                        <element-tab-item @click="myInsuranceTab = '장기·생명'" :on="myInsuranceTab == '장기·생명'">장기·생명<br/><p>{{ insureAccidentList.filter(o => o.type === '민영의료보험' || o.type === '운전자보험' || o.type === '태아보험' || o.type === '정기보험' || o.type === '실손의료보험' || o.type === '건강보험' || o.type === '어린이보험' || o.type === '종신보험' || o.type === '암/2대질병 보험' || o.type === '치아보험' || o.type === '치매보험' ).length }}</p></element-tab-item>
                        <element-tab-item @click="myInsuranceTab = '화재·기타'" :on="myInsuranceTab == '화재·기타'">화재·기타<br/><p>{{ insureAccidentList.filter(o => o.type === '상해보험' || o.type === '펫보험' || o.type === '연금보험' || o.type === '화재보험').length }}</p></element-tab-item>
                      </element-tab>
                    </div>
                  </div>

                  <div id="myinsurance-tab-service">
                    <template v-if="myInsuranceTab === '정비·수리'">
                      <element-insure-repair-item :data="repairList" :type="'사고보상'" :key="'사고보상'"/>
                    </template>
                    <template v-else>
                      <element-insure-item :data="filterList(insureAccidentList)" :type="'사고보상'" :key="'사고보상'"/>
                    </template>
                    <router-link :to="{ name: 'RepairEstimate', query: { customerId: this.$store.state.customer.profile._id } }" />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="section-footer">
        <div class="container">
          <div class="footer-link">
            <router-link :to="{ name: 'FAQ' }">나의 질문과 답변</router-link>
          <img :src="'../static/chevron_right.png'" />
          </div>
          <div class="footer-link">
            <ul>
              <li  @click="clickTerms(index)" > <p @click="statusPopup = true">개인정보 관리</p></li>
              <element-term-popup v-model="statusPopup"/>
            </ul>
          </div>
        </div>
        <div class="container" style="max-width: 760px;">
          <p style="font-size: 11px;" >※ 이 견적서의 보험료는 보험가입일, 보험개발원 적용율, 보험사별 차량가액 및 인수 기준에 따라 변경될 수 있습니다.</p>
        </div>
      </div>

    </div>


  </div>
</template>

<script>
import moment from 'moment'

export default {
  data(){
    return {
      statusPopup : false,
      profile: {},

      introductionTab: "비교견적",
      myInsuranceTab: "전체",

      token: "",

      company: [
        { label: "hd", value: "현대해상" },
        { label: "ss", value: "삼성화재" },
        { label: "db", value: "DB손해보험" },
        { label: "lg", value: "KB손해보험" },
        { label: "ji", value: "MG손해보험" },
        { label: "sd", value: "한화손해보험" },
        { label: "sy", value: "흥국생명" },
        { label: "dh", value: "롯데손해보험" },
        { label: "dy", value: "메리츠화재" }
      ],

      currentList: [],
      insureEstimateList: [],
      insureSubscriptionList: [],
      insureChangeContractList: [],
      insureAccidentList: [],
      repairList: [],
      distance: 0,
    }
  },
  watch: {
    '$route' (n) {
      if(n.name == "MyInsurance") {
        this.setTabNames();
      }
    },
    'introductionTab' (n) {
      if(this.introductionTab != this.$route.query.tab)
        this.$router.replace({ 
          hash: `#${document.documentElement.scrollTop}`,
          query: { tab : n, subtab : this.myInsuranceTab }
        })
    },
    'myInsuranceTab' (n) {
      if(this.myInsuranceTab != this.$route.query.subtab)
        this.$router.replace({ 
          hash: `#${document.documentElement.scrollTop}`,
          query: { tab : this.introductionTab, subtab : n }
        })
    }
  },
  created(){
    this.setTabNames()

    this.$store.dispatch( "customer/refresh" ).then( res => {

      let token = localStorage.eleToken;
      let profile = JSON.parse(localStorage.getItem( "profile" ));

      if(profile){
        if(profile._id){
          this.setUserData();
          this.currentList = this.insureEstimateList;
        }
      }

    });

    //!this.token &&


  },
  methods: {
    fetch(){
      this.setTabNames()
    },
    setUserData: function() {

      let profile = JSON.parse(localStorage.getItem( "profile" ));

      //profile._id = 301313
      // 견적서 목록
      this.$store.dispatch( "estimate/getItems", { "_id": profile._id }).then(res => {

        var list = res.data.data.items;
        var tmp = [];

        list.forEach(o => {
          var c = {};
          c.id = o._id,
          c.type = o.estimate_type + "보험",
          c.title = o.estimate_type + "보험 견적서",
          c.user = o.customerName,
          c.carNumber = o.auto_number,
          // c.status = o.status,
          c.period_start = moment(o.estimate_date_start).format('YYYY.MM.DD'),
          c.period_end = moment(o.estimate_date_end).format('YYYY.MM.DD'),
          c.manager = {
            name: o.adminName,
            profileUrl: o.adminProfileUrl,
            phone: o.adminPhone,
            kakaotalk: o.adminKakaoLink,
          }
          tmp.push(c);
        })

        this.insureEstimateList = tmp;

      });

      //가입보험 목록
      this.$store.dispatch( "contract/getItems", { "_id": profile._id } ).then(res => {

        var contractIds = [];
        for(var i = 0; i< res.data.data.items.length; i++){
            contractIds.push(res.data.data.items[i]._id );
        }

        var list = res.data.data.items;
        var tmp = [];
        var cnt = 0;

        this.$store.dispatch( "contract/getContractStatus", contractIds ).then( res => {

        var statusList = res.data.data.items;

        list.forEach(o => {

          var c = {};
          c.id = o._id,
          c.type = o.contract_type + "보험",
          // c.title = this.company.filter(oo => oo.label == o.companyName).value, // 변경 요청
          c.title = o.companyName,
          c.user = o.customerName,
          c.carNumber = o.auto_number,
          c.status = statusList[cnt++][0].status,
          c.period_start = moment(o.contract_date_start).format('YYYY.MM.DD'),
          c.period_end = moment(o.contract_date_end).format('YYYY.MM.DD'),
          c.manager = {
            name: o.adminName,
            profileUrl: o.adminProfileUrl, // adminProfileUrl 은 전달되지 않음.
            phone: o.adminPhone, // adminPhone 은 전달되지 않음.
            kakaotalk: o.adminKakaoLink,
          }


          tmp.push(c);

        })

        this.insureSubscriptionList = tmp;

        })
      });

      //계약변경 목록

      this.$store.dispatch( "contract/getAuditItems", { "_id": profile._id } ).then(res => {


        var contractIds = [];
        for(var i = 0; i< res.data.data.items.length; i++){
            contractIds.push(res.data.data.items[i].contract_id );
        }

        var list = res.data.data.items;
        var tmp = [];
        var cnt = 0;

        this.$store.dispatch( "contract/getContractStatus", contractIds ).then( res => {


        var statusList = res.data.data.items;

        list.forEach(o => {
          var c = {};
          c.id = o.contract_id,
          c.auid = o._id,
          c.endorsement_type = o.contract_endorsement_type,
          c.endorsement_date = o.contract_endorsement_date,
          c.type = o.contract_type + "보험",
          // c.title = this.company.filter(oo => oo.label == o.companyName).value,  // 변경 요청
          c.title = o.companyName,
          c.user = o.customerName,
          c.carNumber = o.auto_number,
          c.status = statusList[cnt++][0].status,
          c.period_start = moment(o.contract_date_start).format('YYYY.MM.DD'),
          c.period_end = moment(o.contract_date_end).format('YYYY.MM.DD'),
          c.manager = {
            name: o.admin_name,
            profileUrl: o.adminProfileUrl,
            phone: o.admin_contact_phone,
            kakaotalk: o.adminKakolink,
          }
          tmp.push(c);
        });

        this.insureChangeContractList = tmp;
        })
      })

      
      // 사고보상 목록
      this.$store.dispatch('repair/getItems', {params: {search_customer_id: profile._id, page: 1, size: 100}}).then(({ data }) => {
        const {data: {items, total}} = data
        this.repairList = items.map(item => {
          return {
            ...item,
            id: item.contract_id,
            manager: {
              name: item.admin_name_report,
              profileUrl: item.adminProfileUrl,
              phone: item.admin_contact_phone,
              kakaotalk: item.adminKakolink,
            },
            repair_estimate_date: moment(item.repair_estimate_date).format('YYYY.MM.DD')
          }
        })
      })
      
      this.$store.dispatch( "contract/getAccidentItems", { "_id": profile._id } ).then(res => {

        var contractIds = [];
        var auto_numbers = [];

        for(var i = 0; i< res.data.data.items.length; i++){
            contractIds.push(res.data.data.items[i].contract_id );

        }

        for(var i = 0; i< res.data.data.items.length; i++){
          this.$store.dispatch( "contract/getAutoData", { "auto_id": res.data.data.items[i].auto_id  } ).then(res => {
              auto_numbers.push(res.data.data[0].auto_number);
          })
        }

        var list = res.data.data.items;
        var tmp = [];
        var cnt = 0;


        this.$store.dispatch( "contract/getContractStatus", contractIds ).then( res => {

        var statusList = res.data.data.items;


        list.forEach(o => {
          var c = {};
          c.id = o.contract_id,
          c.type = o.estimate_type + "보험",
          c.accidentType = o.contract_accident_status,
          // c.title = this.company.filter(oo => oo.label == o.companyName).value,  // 변경 요청
          c.title = o.companyName,
          c.user = o.customerName,
          c.carNumber = auto_numbers[cnt],
          c.status = statusList[cnt++][0].status,
          c.period_start = moment(o.contract_date_start).format('YYYY.MM.DD'),
          c.period_end = moment(o.contract_date_end).format('YYYY.MM.DD'),
          c.manager = {
            name: o.admin_name,
            profileUrl: o.adminProfileUrl,
            phone: o.admin_contact_phone,
            kakaotalk: o.adminKakolink,
          }
          tmp.push(c);
        });

        this.insureAccidentList = tmp;
        })
      })

      // 견인거리
      this.$store.dispatch('customer/getDistance', { customer_id: profile._id }).then(res => {
        const { data } = res.data;

        this.distance = data.distance;
      })
    },

    setTabNames() {
      const { tab, subtab } = this.$route.query;
      const _subtab = {
        '사고보상_전체': '정비·수리',
        '비교견적_정비·수리': '전체',
        '가입보험_정비·수리': '전체',
        '계약변경_정비·수리': '전체',
      }[tab + '_' + subtab];
      const _subtabEmpty = { '사고보상': '정비·수리' }[tab] || '전체';

      this.introductionTab = '비교견적';
      this.myInsuranceTab = _subtabEmpty;

      if (tab) {
        this.introductionTab = tab;
      }

      if (subtab) {
        return this.myInsuranceTab = _subtab || subtab;
      }

      this.$router.replace({ query: { tab : this.introductionTab, subtab: this.myInsuranceTab }});
    },

    changeTab: async function( tab, list ){
      this.myInsuranceTab = tab;

      await this.$nextTick(() => {
        this.currentList = this.filterList(list);
      });
    },

    filterList(list) {
      const _list = {
        '자동차': ['자동차보험'],
        '장기·생명': ['민영의료보험', '운전자보험', '태아보험', '정기보험', '실손의료보험', '어린이보험', '종신보험', '암보험', '치아보험', '치매보험'],
        '화재·기타': ['상해보험', '펫보험', '연금보험', '화재보험'],
        '정비·수리': ['정비', '수리']
      };

      if (this.myInsuranceTab === "전체") {
        return list;
      }

      return list.filter(o => _list[this.myInsuranceTab].indexOf(o.type) !== -1);
    },
    logout() {
      this.currentList = []

      this.insureEstimateList = []

      this.insureSubscriptionList = []

      this.insureChangeContractList = []
      this.insureAccidentList = []

      this.repairList = []

      this.$store.dispatch( "customer/getAuth", {} ).then(res => {
      });
    },
    clickTerms( index ) {
      this.value[index].value = !this.value[index].value;
    },
    test() {
      this.$store.dispatch( "customer/test", {} ).then(res => {
      });
    },
     moment: function () {
      return moment();
    }
  }
}
</script>

<style scoped>
.mb-1 {
  margin-bottom: 1rem !important;
}
.distance-guide {
  color: #174be6;
  border: 1px solid #174be6;
  border-radius: 4px;
  height: 50px;
  line-height: 50px;
  margin-top: 2rem;
  margin-bottom: 3rem;
  width: 20%;
  margin: 0 auto;
}
</style>